import { render, staticRenderFns } from "./IconBadgeStatusColumn.vue?vue&type=template&id=10779e65&scoped=true&"
import script from "./IconBadgeStatusColumn.vue?vue&type=script&lang=js&"
export * from "./IconBadgeStatusColumn.vue?vue&type=script&lang=js&"
import style0 from "./IconBadgeStatusColumn.vue?vue&type=style&index=0&id=10779e65&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10779e65",
  null
  
)

export default component.exports